// Portal-Konto anlegen (Mieter, Eigentümer), ohne die Sitzung des angemeldeten Verwalters zu ändern.
// supabase.auth.signUp im normalen Client kann – je nach Projekteinstellung – die neue Sitzung
// übernehmen und den Verwalter auf das neue Konto umschalten. Deshalb ein eigener Client ohne
// gespeicherte Sitzung (wie im Team-Bereich, TeamMitarbeiterErstellenModal).

import { createClient, type AuthResponse } from '@supabase/supabase-js';
import { isDemoMode, supabaseAnonKey, supabaseUrl } from '../supabase/client';

export async function kontoAnlegen(params: { email: string; password: string; data: Record<string, unknown> }): Promise<AuthResponse> {
  if (isDemoMode()) {
    // Im Demo-Modus kein echtes Konto anlegen
    return { data: { user: null, session: null }, error: new Error('Im Demo-Modus werden keine Zugänge angelegt.') } as unknown as AuthResponse;
  }
  const temp = createClient(supabaseUrl, supabaseAnonKey, {
    auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false, storageKey: 'konto-anlegen' },
  });
  return temp.auth.signUp({ email: params.email, password: params.password, options: { data: params.data } });
}
